import { supabase, isSupabaseConfigured } from '@/integrations/supabase';

/**
 * 이메일과 비밀번호로 Supabase 로그인을 수행합니다.
 * @param {{ email: string, password: string }} params
 */
export async function signInWithEmail({ email, password }) {
  if (!isSupabaseConfigured) {
    return { data: null, error: new Error('Supabase 환경 변수가 설정되지 않았습니다.') };
  }

  if (!email || !password) {
    return { data: null, error: new Error('이메일과 비밀번호를 입력해주세요.') };
  }

  try {
    const { data, error } = await supabase.auth.signInWithPassword({
      email: email.trim(),
      password,
    });

    if (error) {
      return { data: null, error };
    }

    return { data, error: null };
  } catch (err) {
    return {
      data: null,
      error: err instanceof Error ? err : new Error('로그인 중 오류가 발생했습니다.'),
    };
  }
}
